import { Link, useLocation, useNavigation } from "@remix-run/react";
import { ChevronRight } from "@ruter-ds-next/icons";
import { Logo } from "@ruter-ds-next/logos";
import React from "react";

import { MobileNavigationMenu } from "./MobileNavigationMenu";
import { Spinner } from "./Spinner";

export function NavBar({
  className = "",
  ...props
}: React.ComponentPropsWithoutRef<"nav">) {
  const navigation = useNavigation();
  const location = useLocation();

  return (
    <>
      <nav
        className={`hidden items-center justify-between md:flex ${className}`}
        {...props}
      >
        <div className="flex items-center">
          <div
            className={`mb-1 overflow-hidden transition-all ${
              navigation.state !== "idle" ? "mr-2 w-6" : "w-0"
            }`}
          >
            <Spinner className="size-4 fill-main-ruter-red" />
          </div>
          <Link
            to={"/"}
            className="flex gap-4 font-title-s-md text-main-ruter-red no-underline"
          >
            <Logo className="h-5" /> Vehicle Verification Service
          </Link>
        </div>
        <ul className={`m-0 flex list-none gap-8`}>
          <li className="m-0">
            <Link
              to="/vvs"
              className={`text-light-ink-primary ${
                location?.pathname.startsWith("/vvs")
                  ? "font-body-m-sm underline"
                  : "no-underline"
              }`}
            >
              Vehicle Verifications
            </Link>
          </li>
          <li className="m-0">
            <Link
              to="/vehicle"
              className={`text-light-ink-primary ${
                location?.pathname.startsWith("/vehicle")
                  ? "font-body-m-sm underline"
                  : "no-underline"
              }`}
            >
              Vehicles
            </Link>
          </li>
          <li className="m-0">
            <Link
              to="/logout"
              className={`text-light-ink-primary no-underline`}
            >
              Log out
            </Link>
          </li>
        </ul>
      </nav>
      <HamburgerMenu className={`md:hidden ${className}`} />
    </>
  );
}

export function HamburgerMenu({
  className = "",
  ...props
}: React.ComponentPropsWithoutRef<typeof NavBar>) {
  const [open, setOpen] = React.useState(false);
  const navigation = useNavigation();
  const location = useLocation();

  React.useEffect(() => {
    if (navigation.state === "loading") {
      setOpen(false);
    }
  }, [navigation]);

  return (
    <nav
      className={`flex items-center justify-between ${className}`}
      {...props}
    >
      <div className="flex items-center">
        <div
          className={`mb-1 overflow-hidden transition-all ${
            navigation.state !== "idle" ? "mr-2 w-6" : "w-0"
          }`}
        >
          <Spinner className="size-4 fill-main-ruter-red" />
        </div>
        <Link
          to={"/"}
          className="flex flex-col items-start gap-2 font-title-s-md text-label-s-md text-main-ruter-red no-underline"
        >
          <Logo className="h-4" /> Vehicle Verification Service
        </Link>
      </div>
      <MobileNavigationMenu
        open={open}
        onOpenChange={(state) => setOpen(state)}
        className="flex flex-col"
      >
        <Link
          to="/vvs"
          className={`my-4 flex justify-between p-4 text-light-ink-primary transition-all hover:pr-2 ${
            location?.pathname.startsWith("/vvs")
              ? "font-body-m-sm underline"
              : "no-underline"
          }`}
        >
          Vehicle Verifications
          <ChevronRight className="size-4" />
        </Link>
        <Link
          to="/vehicle"
          className={`my-4 flex justify-between p-4 text-light-ink-primary transition-all hover:pr-2 ${
            location?.pathname.startsWith("/vehicle")
              ? "font-body-m-sm underline"
              : "no-underline"
          }`}
        >
          Vehicles
          <ChevronRight className="size-4" />
        </Link>
        <Link
          to="/logout"
          className="my-4 flex justify-between p-4 text-light-ink-primary transition-all hover:pr-2"
        >
          Log out
          <ChevronRight className="size-4" />
        </Link>
      </MobileNavigationMenu>
    </nav>
  );
}
